import { SignIn, useAuth } from '@clerk/clerk-react'
import { Navigate, useLocation } from 'react-router'

export function Login() {
  const { isSignedIn, isLoaded } = useAuth()
  const location = useLocation()
  const from = (location.state as { from?: Location })?.from?.pathname || '/dashboard'

  if (!isLoaded) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <div className="animate-spin h-8 w-8 border-2 border-primary border-t-transparent rounded-full" />
      </div>
    )
  }

  if (isSignedIn) {
    return <Navigate to={from} replace />
  }

  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm">
        <SignIn
          routing="virtual"
          fallbackRedirectUrl="/dashboard"
          withSignUp={false}
          oauthFlow="redirect"
          appearance={{
            elements: {
              footerAction: { display: 'none' },
            },
          }}
        />
      </div>
    </div>
  )
}